"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePresentInViewPortContextProvider = exports.PresentInViewPortContextProvider = exports.PresentInViewPortContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.PresentInViewPortContext = (0, react_1.createContext)({});
const PresentInViewPortContextProvider = ({ children, onEnteringViewPort, }) => {
    const [visibleElements, setVisibleElements] = (0, react_1.useState)([]);
    const observer = new IntersectionObserver((entry) => {
        const elements = [];
        entry.forEach((element) => {
            if (element.isIntersecting) {
                elements.push(element.target);
                unwatch(element.target);
            }
        });
        setVisibleElements(elements);
    });
    (0, react_1.useEffect)(() => {
        if (visibleElements.length > 0) {
            onEnteringViewPort(visibleElements);
            setVisibleElements([]);
        }
    }, [visibleElements, onEnteringViewPort]);
    const watch = (element) => {
        observer.observe(element);
    };
    const unwatch = (element) => {
        observer.unobserve(element);
    };
    const value = (0, react_1.useMemo)(() => ({ watch, unwatch }), []);
    return (0, jsx_runtime_1.jsx)(exports.PresentInViewPortContext.Provider, { value: value, children: children });
};
exports.PresentInViewPortContextProvider = PresentInViewPortContextProvider;
const usePresentInViewPortContextProvider = () => {
    const context = (0, react_1.useContext)(exports.PresentInViewPortContext);
    if (!context) {
        throw new Error('Must use usePresentInViewPortContextProvider in PresentInViewPortContext');
    }
    return context;
};
exports.usePresentInViewPortContextProvider = usePresentInViewPortContextProvider;
//# sourceMappingURL=PresentInViewPortContextProvider.js.map